const generateTimestamp = () => {
    const now = new Date()
    
    const format = num => String(num).padStart(2, '0')
    return `${now.getFullYear()}${format(now.getMonth() + 1)}${format(now.getDate())}${format(now.getHours())}${format(now.getMinutes())}${format(now.getSeconds())}`
}

export default generateTimestamp